<div class="app-navbar-header__location" id="appNavbar" #appNavBarRef>
  <nav class="app-navbar-header" aria-label="Top Toolbar">
    @if ((isScreenSmall | async)) {
      <button mat-button class="sidenav-toggle" (click)="toggleSidenav.emit()">
        <mat-icon inline=true>menu</mat-icon>
      </button>
    }

    <a class="app-navbar-header__brand" (click)="getPageToRedirect()" aria-label="ClinDx">
      <img class="app-navbar-header__logo1" src="{{cdnImageUrl}}LabPort_logo.png" alt="ClinDx">
      <img class="app-navbar-header__logo2" src="{{cdnImageUrl}}LabPort_logo_small.png" alt="ClinDx">
    </a>
    @if (!(isScreenSmall | async)) {
      <nav class="app-navbar-header__navigation" id="highlight-navbar" aria-label="Result">
        <ul class="page-links">
          <li routerLinkActive #rla="routerLinkActive" [class.active]="rla.isActive" routerLink="/home"><a class="main-links"><span>Home</span></a></li>
          @for (link of matMenuLinks; track link) {
            <li routerLinkActive #rla="routerLinkActive" [class.active]="rla.isActive">
              @if (link.childUrl.length > 0) {
                <a class="main-links"><span>{{link.displayText}}</span></a>
              }
              @if (link.childUrl.length === 0) {
                <a class="main-links" [routerLink]="link.url"><span>{{link.displayText}}</span></a>
              }
              @if (link.childUrl.length > 0) {
                <ul>
                  <div class="ul-cover">
                   @for (ullink of link.childUrl; track ullink) {
                    <li routerLinkActive #rla="routerLinkActive" [class.active]="rla.isActive" [routerLinkActiveOptions]="{exact:true}" class="sub-section">
                      @if (ullink && (ullink === 'Lab Configuration' ||ullink === '/manage-internal-users,/manage-customer-users' || ullink === '/manage-customer-users,/manage-internal-users')) {
                        <a class="sub-links">
                          <span>{{submenuURLtext[ullink]}}</span>
                          @if (ullink === 'Lab Configuration') {
                            <span class="arrow"></span>
                          }
                          @if (ullink === '/manage-internal-users,/manage-customer-users' || ullink === '/manage-customer-users,/manage-internal-users') {
                            <span class="arrow"></span>
                          }
                        </a>
                      }
                      @if (ullink && (ullink !== 'Lab Configuration' && ullink !== '/manage-internal-users,/manage-customer-users' && ullink !== '/manage-customer-users,/manage-internal-users')) {
                        @if (ullink === 'STANDING_ORDERS') {
                          <a class="sub-links" routerLink="/order" [queryParams]="{viewType: 'standing'}" routerLinkActive #standingOrdersLink="routerLinkActive" [routerLinkActiveOptions]="{exact:true}">
                            <span>View Standing Orders</span>
                          </a>
                        }
                        @if (ullink !== 'STANDING_ORDERS') {
                          <a class="sub-links" [routerLink]="ullink">
                            <span>{{submenuURLtext[ullink]}}</span>
                          </a>
                        }
                      }
                      @if (ullink === 'Lab Configuration') {
                        <ul>
                          <li [class.active]="URL === '/questions'" routerLink="/questions"><a><span>Questions</span></a></li>
                          <li [class.active]="URL === '/tests'" routerLink="/tests"><a><span>Tests/Panels</span></a></li>
                          <li [class.active]="URL === '/payors'" routerLink="/payors"><a><span>Payors</span></a></li>
                        </ul>
                      }
                      @if (ullink === '/manage-internal-users,/manage-customer-users' || ullink === '/manage-customer-users,/manage-internal-users') {
                        <ul>
                          <li [class.active]="URL === '/manage-internal-users'" routerLink="/manage-internal-users"><a><span>Internal Users</span></a></li>
                          <li [class.active]="URL === '/manage-customer-users'" routerLink="/manage-customer-users"><a><span>Customer Users</span></a></li>
                        </ul>
                      }
                    </li>
                  }
                  </div>
                </ul>
              }
            </li>
          }
          <!-- External Link Display for Resource Center/Test Menu link  -->
          <li *ngIf="buNavigationLink" class="external-link-item">
          <a class="main-links" href="javascript:void(0)" (click)="openExternalLink(buNavigationLink.url)">
            <span>{{buNavigationLink.displayName}}</span>
          </a>
        </li>
        </ul>
      </nav>
    }

    <div class="flex-spacer"></div>
    <div name="cp_toolbar_user" class="cp_toolbar_user">
      <button [matMenuTriggerFor]="usermenu" mat-button class="app-navbar-header--button__user" name="cp_toolbar_user_icon">
        <mat-icon inline=true class="user-icon-color">account_circle</mat-icon>
      </button>
      @if (!(isScreenSmall | async)) {
        <span class="display-user"> {{getUserName()}}</span>
      }
      <mat-menu #usermenu="matMenu">
        <button name="cp_toolbar_user_profile" routerLink='/update-profile' mat-menu-item>Edit your Details</button>
        <button name="cp_toolbar_user_change_password" routerLink='/change-password' mat-menu-item>Change
        Password</button>
        @if (isUserExternal) {
          <button name="cp_toolbar_user_email_notification" routerLink='/email-notification' mat-menu-item
          >Email Notifications</button>
        }
        <button name="cp_toolbar_user_logout" mat-menu-item (click)="logout()">Log off</button>
      </mat-menu>
    </div>
  </nav>
</div>
